import { render } from "./LoadingState.vue?vue&type=template&id=8b6f2294"
import script from "./LoadingState.vue?vue&type=script&lang=js"
export * from "./LoadingState.vue?vue&type=script&lang=js"
script.render = render

export default script